import { OrderState } from '@sg/graphql-schema';

import {
  type CartDataFragment,
  type CartQuery,
  type SubmitBagOrderWithPaymentMethodMutation,
} from '../../../../../graphql/operations.generated';
import { CartDocument } from '../../../../../hooks/useCart/GraphQL/Cart.generated';

import type { Cache } from '@urql/exchange-graphcache';

// ────────────────────────────────────────────────────────────────────────────────

export function updateCartCache(cache: Cache, responseWithCart: MutationResponseWithCart) {
  const cart = responseWithCart.cart;

  if (!cart) return;

  cache.updateQuery({ query: CartDocument }, (data) => {
    if (!data) return { __typename: 'Query', cart };

    data.cart = cart;

    return data;
  });
}

export function clearCartCacheEntry(cache: Cache) {
  cache.updateQuery({ query: CartDocument }, (data) => {
    if (data) data.cart = null;

    return data;
  });
}

export function clearCanceledGroupOrderCartCacheEntry(cache: Cache, response: CartQuery) {
  const cart = response.cart;
  const isGroupOrder = Boolean(cart?.multipartyDetails);
  const isCanceled = cart?.orderState === OrderState.Canceled;

  if (!isGroupOrder || !isCanceled) return;

  clearCartCacheEntry(cache);
}

export function invalidateCartCacheEntry(
  cache: Cache,
  response: SubmitBagOrderWithPaymentMethodMutation['submitOrderUsingPaymentMethod'],
) {
  const result = response?.__typename;
  const isSubmitted = result === 'SubmitOrderUsingPaymentMethodSuccess';

  if (isSubmitted) {
    clearCartCacheEntry(cache);
  }
}

// ─── TYPES ──────────────────────────────────────────────────────────────────────

export type MutationResponseWithCart = Readonly<{
  cart?: Partial<CartDataFragment>;
  __typename?: string;
}>;
